<template lang="html">
  <div
    id="fsd-app"
    v-tracking-context="{ page_type: webtrekkPageType }"
    class="fsd-app"
    :class="{ 'fsd-app--detail': resultsJobUserSelected }"
  >
    <div class="fsd-body">
      <div class="fsd-list-view fsd-left">
        <div class="fsd-list-view__scroll">
          {{ /* This div is only for intersection events */ }}
          <div
            v-scrolls-into-view="{
              handler: onSearchVisible,
              offHandler: onSearchInvisible,
              margin: '0px',
              threshold: 1
            }"
          />
          <div
            v-tracking-context="{ content_element: 'search_module' }"
            class="fsd-list-view__search-module"
            :class="{ 'fsd-list-view__search-module--sticky': isSearchSticky }"
          >
            <div ref="searchBox" class="fsd-list-view__search">
              <search />
            </div>

            <pills :headline="headline" />
          </div>

          <job-list />

          <transition v-if="!resultsLoading" name="filter">
            <!-- eslint-disable vue/no-v-html -->
            <div class="fsd-sidebar" v-html="resultsSidebar" />
          </transition>
        </div>
      </div>
      <div class="fsd-detail-view fsd-right fsd-right--centered">
        <job-detail />
      </div>
    </div>
    <filter-settings />
    <fsd-rating />
    <fsd-footer />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'

import FilterSettings from './filter_settings.vue'
import FsdFooter from './footer.vue'
import FsdRating from './rating.vue'
import JobDetail from './job_detail.vue'
import JobList from './job_list.vue'
import Pills from './pills.vue'
import Search from './search.vue'

export default {
  components: {
    FsdFooter,
    FsdRating,
    FilterSettings,
    JobDetail,
    Pills,
    JobList,
    Search
  },
  computed: {
    ...mapState([
      'resultsJobUserSelected',
      'resultsCount',
      'resultsSidebar',
      'resultsLoading',
      'searchProfile',
      'searchBoxHtml',
      'isSearchSticky',
      'pageType',
      'consent'
    ]),
    ...mapGetters(['checkedCategoryTags']),
    headline() {
      if (
        this.checkedCategoryTags.length ||
        this.searchProfile.customTags.length
      ) {
        const firstPart = this.$options.filters.t(
          'client.fused.result_headline_filtered',
          { count: this.resultsCount }
        )
        const secondPart =
          this.searchProfile.customTags.length > 0
            ? ' ' +
              this.$options.filters.t(
                'client.fused.result_headline_filtered_end'
              )
            : ''
        return firstPart + secondPart
      } else {
        return this.$options.filters.t(
          'client.fused.result_headline_unfiltered',
          { count: this.resultsCount }
        )
      }
    },
    webtrekkPageType() {
      if (this.pageType) {
        return this.pageType.toLowerCase()
      } else {
        // assume 'joblist' as sensible fallback for webtrekk pagetype
        return 'joblist'
      }
    }
  },
  mounted() {
    // bindSearchBox(this.$refs.searchBox)
    // bindTypeahead()
    // add EventListener for popstate event to handle Browser-Action "back" and update job selection
    window.addEventListener('popstate', this.popstate)
    document.addEventListener('click', this.onAnyClick)

    this.evaluateSearchContext()
    this.registerConsentListeners()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.popstate)
  },
  methods: {
    ...mapMutations(['searchVisibleSet', 'searchStickyToggle']),
    ...mapActions([
      'restoreStateFromHistory',
      'evaluateSearchContext',
      'registerConsentListeners'
    ]),
    onSearchVisible() {
      this.searchVisibleSet(true)
      if (this.isSearchSticky) {
        this.searchStickyToggle(false)
      }
    },
    onSearchInvisible() {
      this.searchVisibleSet(false)
    },
    // see also complementing functionality for header nav; but footer in Rails;
    // ignoring modal for time being (can only be opened by clicking)
    onAnyClick($event) {
      this.$VueEventBus.emit('globalBlur', $event)
    },
    popstate($event) {
      if ($event.state !== null) {
        this.restoreStateFromHistory($event.state)
      }
    }
  }
}
</script>
